export default "__VITE_ASSET__BbkezUPJ__"